<app-normal-navbar></app-normal-navbar>

<div class="site-page-wrapper">
  <!-- Soft Ambient Glow Layers -->
  <div class="site-ambient-bg"></div>

  <!-- Standardized Centered Container -->
  <div class="site-container">

    <!-- ═══════════════ HERO SECTION ═══════════════ -->
    <header class="hero-section">
      <h1 class="hero-title">Contact &amp; Support</h1>

      <p class="hero-subtitle">
        Have questions about our movie data, want to report a bug, have feedback on our Cinephile Journal, or need to
        file a formal copyright or advertising inquiry? We're here to assist.
      </p>

      <div class="hero-meta-row">
        <span class="meta-pill"><strong>Response Time:</strong> Within 24-48 Hours</span>
        <span class="meta-pill"><strong>Availability:</strong> Monday &ndash; Friday</span>
        <span class="meta-pill"><strong>Support Status:</strong> All Systems Operational</span>
      </div>
    </header>

    <!-- ═══════════════ CONTACT CHANNELS GRID ═══════════════ -->
    <div class="policy-sections-list">

      <!-- Four Dedicated Contact Channels -->
      <section class="policy-card">

        <div class="card-header-row">
          <div class="card-icon-box icon-emerald">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path
                d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
              </path>
            </svg>
          </div>
          <div class="header-text-group">
            <span class="section-tag">Direct Inquiries</span>
            <h2 class="card-title">Official Department Communication Channels</h2>
          </div>
        </div>
        <div class="card-body">
          <p>
            Please choose the appropriate inbox for your inquiry to ensure expedited handling by our team:
          </p>

          <div class="grid-two-col">
            <!-- Channel 1: General Inquiries -->
            <div class="contact-channel-card">
              <div class="channel-icon icon-emerald">✉</div>
              <h4>General &amp; Editorial Inquiries</h4>
              <p>For feedback regarding film blogs, editorial recommendations, or general questions about SceneTale.</p>
              <a href="mailto:contact@scenetale.com" class="channel-email-btn">
                contact&#64;scenetale.com &rarr;
              </a>
            </div>

            <!-- Channel 2: Technical Support -->
            <div class="contact-channel-card">
              <div class="channel-icon icon-teal">🔧</div>
              <h4>Technical Support &amp; Bugs</h4>
              <p>Found a glitch in our trivia scoring, missing trailer link, or account session issue? Let us fix it.
              </p>
              <a href="mailto:support@scenetale.com" class="channel-email-btn">
                support&#64;scenetale.com &rarr;
              </a>
            </div>

            <!-- Channel 3: DMCA & Privacy -->
            <div class="contact-channel-card">
              <div class="channel-icon icon-amber">⚖</div>
              <h4>DMCA, Legal &amp; Privacy Officer</h4>
              <p>Formal copyright infringement notices, DMCA takedown requests, and GDPR/CCPA data deletion.</p>
              <a href="mailto:dmca@scenetale.com" class="channel-email-btn">
                dmca&#64;scenetale.com &rarr;
              </a>
            </div>

            <!-- Channel 4: Advertising & Partnerships -->
            <div class="contact-channel-card">
              <div class="channel-icon icon-gold">💼</div>
              <h4>Advertising &amp; Partnerships</h4>
              <p>Questions regarding Google AdSense placement, sponsored film showcases, or business integrations.</p>
              <a href="mailto:partners@scenetale.com" class="channel-email-btn">
                partners&#64;scenetale.com &rarr;
              </a>
            </div>
          </div>
        </div>
      </section>

      <!-- Section: Direct Inquiry Form -->
      <section class="policy-card">

        <div class="card-header-row">
          <div class="card-icon-box icon-teal">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
          </div>
          <div class="header-text-group">
            <span class="section-tag">Quick Dispatch</span>
            <h2 class="card-title">Send Us a Direct Message</h2>
          </div>
        </div>
        <div class="card-body">
          <p>
            You may also dispatch a message directly to our desk. Provide your contact details and a member of our team
            will reply to your verified address.
          </p>

          <form class="contact-form-layout" (submit)="$event.preventDefault()">
            <div class="form-row-two">
              <div class="form-group">
                <label for="contact-name">Your Name</label>
                <input type="text" id="contact-name" class="form-input" placeholder="e.g. Christopher Nolan" required />
              </div>
              <div class="form-group">
                <label for="contact-email">Your Email Address</label>
                <input type="email" id="contact-email" class="form-input" placeholder="e.g. director@example.com"
                  required />
              </div>
            </div>

            <div class="form-group">
              <label for="contact-subject">Inquiry Subject</label>
              <select id="contact-subject" class="form-input form-select">
                <option value="general">General Inquiry / Cinema Question</option>
                <option value="trivia">Trivia Suggestion or Feedback</option>
                <option value="bug">Report a Technical Bug or Data Error</option>
                <option value="dmca">DMCA or Copyright Claim</option>
                <option value="ads">Advertising &amp; Sponsorship</option>
              </select>
            </div>

            <div class="form-group">
              <label for="contact-message">Your Message</label>
              <textarea id="contact-message" class="form-input form-textarea" rows="4"
                placeholder="Describe your question or feedback in detail..." required></textarea>
            </div>

            <div class="form-submit-row">
              <a href="mailto:contact@scenetale.com" class="btn-primary-pill">
                Dispatch Email to Support Desk &rarr;
              </a>
              <span class="form-guarantee">🔒 Your email is never shared with third parties.</span>
            </div>
          </form>
        </div>
      </section>

      <!-- Section: Frequently Asked Questions (FAQ) -->
      <section class="policy-card">

        <div class="card-header-row">
          <div class="card-icon-box icon-amber">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
          </div>
          <div class="header-text-group">
            <span class="section-tag">Quick Answers</span>
            <h2 class="card-title">Frequently Asked Questions</h2>
          </div>
        </div>
        <div class="card-body">
          <div class="faq-accordion-list">

            <div class="faq-card">
              <h4 class="faq-question">
                <span class="faq-q-badge">Q</span>
                Where does SceneTale retrieve its movie and TV data?
              </h4>
              <p class="faq-answer">
                All cinema titles, synopses, cast rosters, release dates, and posters are supplied by <strong>The Movie
                  Database (TMDB) API</strong>. This product uses the TMDB API but is not endorsed or certified by TMDB.
                All posters and images are the property of their respective film studios.
              </p>
            </div>

            <div class="faq-card">
              <h4 class="faq-question">
                <span class="faq-q-badge">Q</span>
                Is SceneTale free to use?
              </h4>
              <p class="faq-answer">
                Yes! SceneTale is 100% free for all film lovers. You can explore movies, read our cinema journal, and
                play trivia with zero subscription fees. We support platform maintenance through clean, family-friendly
                advertising via Google AdSense.
              </p>
            </div>

            <div class="faq-card">
              <h4 class="faq-question">
                <span class="faq-q-badge">Q</span>
                How are trivia answers and leaderboard rankings verified?
              </h4>
              <p class="faq-answer">
                Our questions are verified by cinephile editors and cinema archivists. Trivia scoring uses automated
                server timestamps to calculate bonus points for speed and accuracy. In the event of a factual dispute,
                you can email <a href="mailto:support@scenetale.com" class="inline-link">support&#64;scenetale.com</a>
                with the question ID for rapid review.
              </p>
            </div>

            <div class="faq-card">
              <h4 class="faq-question">
                <span class="faq-q-badge">Q</span>
                How can I request deletion of my account or personal data?
              </h4>
              <p class="faq-answer">
                Under GDPR and CCPA, you have the absolute right to have your profile and trivia score history
                permanently removed. Send a message to <a href="mailto:privacy@scenetale.com"
                  class="inline-link">privacy&#64;scenetale.com</a> with the subject "Data Deletion Request" and we will
                process it within 48 hours.
              </p>
            </div>

          </div>
        </div>
      </section>

    </div>

    <!-- ═══════════════ BOTTOM TRUST BANNER ═══════════════ -->
    <section class="bottom-trust-card">
      <div class="trust-content">
        <h3>Need More Information?</h3>
        <p>Explore our complete legal, copyright, and privacy policies at any time.</p>
        <div class="trust-actions">
          <a routerLink="/about" class="btn-primary-pill">About SceneTale</a>
          <a routerLink="/privacy-policy" class="btn-secondary-pill">Privacy Policy &rarr;</a>
          <a routerLink="/disclaimer" class="btn-secondary-pill">Disclaimer &amp; DMCA &rarr;</a>
        </div>
      </div>
    </section>

  </div>
</div>

<app-footer></app-footer>